module.exports = __webpack_public_path__ + "media/assets/img/flags/uk-UK-c4a2a98f13baf7a848b090fa5f0d5a59.png";